// Claude 2026-09-24 · "My genres" page. Backend unchanged: genre-link (email me my link) and
// genre-prefs (read/save with the signed ?cid&exp&sig link). Genre text is set with textContent.
const root = document.querySelector('[data-bmg]');
if (root) init(root);

function init(root) {
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  const api = root.dataset.bmgApi.replace(/\/$/, '');
  const min = Number(root.dataset.bmgMin) || 4;
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const states = $$('[data-bmg-state]');
  const genres = $$('[data-bmg-genre]');
  let picked = [], original = [], link = null, saving = false;

  function show(name, focus = false) {
    states.forEach((s) => { s.hidden = s.dataset.bmgState !== name; });
    const el = $(`[data-bmg-state="${name}"]`);
    if (focus) { el.focus?.({ preventScroll: true }); el.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' }); }
  }
  function flash(text) { const f = $('[data-bmg-flash]'); f.textContent = text; f.hidden = !text; }

  // ---------- email me my link ----------
  const email = $('[data-bmg-email]'), send = $('[data-bmg-send]');
  email.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); send.click(); } });
  send.addEventListener('click', async () => {
    const v = email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { flash('That email doesn’t look right. Try again?'); email.focus(); return; }
    flash(''); send.disabled = true; send.textContent = 'Sending…';
    try {
      const res = await fetch(`${api}/genre-link`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: v }) });
      if (!res.ok) throw new Error();
      $('[data-bmg-sent-to]').textContent = v;
      show('sent', true);
    } catch { flash('We couldn’t send that just now. Please try again in a minute.'); }
    finally { send.disabled = false; send.textContent = 'Email me my link'; }
  });
  $('[data-bmg-again]').addEventListener('click', () => { show('request'); email.focus(); email.select(); });

  // ---------- editor ----------
  function paint() {
    genres.forEach((b) => b.setAttribute('aria-pressed', String(picked.includes(b.dataset.bmgGenre))));
    const n = picked.length, ready = n >= min;
    $('[data-bmg-count]').textContent = ready ? `${n} picked ✓` : `${n} / ${min}`;
    $('[data-bmg-count]').classList.toggle('is-ready', ready);
    $('[data-bmg-progress]').style.width = `${Math.min(100, (n / min) * 100)}%`;
    const changed = [...picked].sort().join('|') !== [...original].sort().join('|');
    $('[data-bmg-save]').disabled = !ready || !changed || saving;
    $('[data-bmg-save-msg]').textContent = !ready ? `${min - n} more ${min - n === 1 ? 'genre' : 'genres'} to go.` : changed ? 'Looks great. Save when you’re ready.' : 'These are your current genres.';
    $('[data-bmg-reset]').hidden = !changed || !original.length;
  }
  genres.forEach((b) => b.addEventListener('click', () => {
    if (saving) return;
    const g = b.dataset.bmgGenre;
    picked = picked.includes(g) ? picked.filter((x) => x !== g) : [...picked, g];
    $('[data-bmg-error]').hidden = true;
    paint();
  }));
  $('[data-bmg-reset]').addEventListener('click', () => { picked = [...original]; paint(); });
  $('[data-bmg-surprise]').addEventListener('click', async () => {
    const btn = $('[data-bmg-surprise]');
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    if (!calm) for (let i = 0; i < 12; i++) { const b = genres[Math.floor(Math.random() * genres.length)]; b.classList.add('is-flash'); await new Promise((r) => setTimeout(r, 55 + i * 6)); b.classList.remove('is-flash'); }
    const count = 4 + Math.floor(Math.random() * 3);
    picked = genres.map((b) => [Math.random(), b.dataset.bmgGenre]).sort((a, b) => a[0] - b[0]).slice(0, count).map((x) => x[1]);
    paint();
    btn.removeAttribute('aria-busy');
  });

  $('[data-bmg-save]').addEventListener('click', async () => {
    if (!link || picked.length < min || saving) return;
    saving = true; paint();
    const btn = $('[data-bmg-save]'); btn.textContent = 'Saving…';
    try {
      const res = await fetch(`${api}/genre-prefs`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...link, genres: picked }) });
      const d = await res.json().catch(() => ({}));
      if (res.status === 401 || res.status === 403) return expired();
      if (!res.ok || !d.ok) throw new Error(d.error === 'min4' ? `Pick at least ${min} genres.` : 'Your genres couldn’t be saved. Please try again.');
      original = [...picked];
      const list = $('[data-bmg-saved-list]'); list.replaceChildren(...picked.map((g) => { const li = document.createElement('li'); li.textContent = g; return li; }));
      $('[data-bmg-sync]').textContent = d.orderSync === 'pending'
        ? 'Your profile is updated. We couldn’t update an open box order automatically, so if a box is due soon, reply to your order email and we’ll switch it by hand.'
        : d.stamped > 0 ? `Your next box and ${d.stamped === 1 ? 'your open order' : `${d.stamped} open orders`} now follow these picks.` : 'Your next box will follow these picks.';
      show('saved', true);
    } catch (e) {
      const er = $('[data-bmg-error]'); er.textContent = e.message || 'Something went wrong. Please try again.'; er.hidden = false;
    } finally { saving = false; $('[data-bmg-save]').textContent = 'Save my genres'; paint(); }
  });
  $('[data-bmg-edit-again]').addEventListener('click', () => { show('edit', true); paint(); });

  function expired() {
    link = null; saving = false;
    try { sessionStorage.removeItem('bmg_link'); } catch { /* ignore */ }
    show('request');
    flash('That link has expired or was already replaced. Enter your email and we’ll send a fresh one.');
    email.focus();
  }

  // ---------- boot ----------
  const qs = new URLSearchParams(location.search);
  let cid = qs.get('cid'), exp = qs.get('exp'), sig = qs.get('sig');
  // Keep the private link out of the address bar (screenshots, shared tabs). It lives in this tab's
  // session only, so a refresh still works and closing the tab forgets it.
  if (cid && exp && sig) {
    try { sessionStorage.setItem('bmg_link', JSON.stringify({ cid, exp, sig })); } catch { /* private mode */ }
    ['cid', 'exp', 'sig'].forEach((k) => qs.delete(k));
    history.replaceState(null, '', location.pathname + (qs.toString() ? `?${qs}` : '') + location.hash);
  } else {
    try { ({ cid, exp, sig } = JSON.parse(sessionStorage.getItem('bmg_link') || '{}')); } catch { /* ignore */ }
  }
  if (!(cid && exp && sig)) { show('request'); return; }
  link = { cid, exp, sig };
  show('loading');
  fetch(`${api}/genre-prefs?${new URLSearchParams(link)}`, { headers: { Accept: 'application/json' } })
    .then(async (res) => {
      if (res.status === 401 || res.status === 403) return expired();
      if (!res.ok) throw new Error();
      const d = await res.json();
      original = (Array.isArray(d.genres) ? d.genres : []).filter((g) => genres.some((b) => b.dataset.bmgGenre === g));
      picked = [...original];
      $('[data-bmg-hello]').textContent = d.firstName ? `Hi ${d.firstName}, what are you in the mood for?` : 'What are you in the mood for?';
      show('edit'); paint();
    })
    .catch(() => { show('request'); flash('We couldn’t open your profile just now. Try the link again in a minute, or request a fresh one below.'); });
}
